import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'STUDENT_COURSE_UPGRADE_V2_POST',
  POST_SUCCESS: 'STUDENT_COURSE_UPGRADE_V2_POST_SUCCESS',
  POST_FAILURE: 'STUDENT_COURSE_UPGRADE_V2_POST_FAILURE',
  GET: 'STUDENT_COURSE_UPGRADE_V2_GET',
  GET_SUCCESS: 'STUDENT_COURSE_UPGRADE_V2_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_COURSE_UPGRADE_V2_GET_FAILURE',
  EMPTY_STORE_DATA: 'EMPTY_UPGRADE_V2_STORE_DATA',
};

export const get = actions.get(id => `${BASE_URL}/student-course-upgrade-v2/${id}`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const post = actions.post(id => `${BASE_URL}/student-course-upgrade-v2/${id}`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const emptyStoreData = payload => dispatch => {
  dispatch({ type: ACTIONS.EMPTY_STORE_DATA, payload });
};
